import { render, staticRenderFns } from "./Srpq.vue?vue&type=template&id=9547a31c&scoped=true"
import script from "./Srpq.vue?vue&type=script&lang=js"
export * from "./Srpq.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/portfolio.css?vue&type=style&index=0&id=9547a31c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9547a31c",
  null
  
)

export default component.exports